<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
     <h2 class="m-0">Set dates</h2>
  </div>
  <div class="prese_button">
     <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
     </button>
  </div>
</div>

     <mat-dialog-content style="padding-bottom: 0px;">
      <div class="form-cont">
        <form class="example-form">
      <div class="nw_all mb-3_t">
        <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
          <mat-label>From Date</mat-label>
          <input matInput [matDatepicker]="fromDatePicker" readonly [(ngModel)]="fromDate" name="fromdate" [min]="today">
          <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #fromDatePicker></mat-datepicker>
        </mat-form-field>
     </div>
     <div class="nw_all mb-3_t">
        <mat-form-field appearance="outline" (click)="toDatePicker.open()">
          <mat-label>To Date</mat-label>
          <input matInput [matDatepicker]="toDatePicker" readonly [(ngModel)]="toDate" name="todate" [min]="today" (dateChange)="validateDateRange()" #toDateInput="ngModel">
          <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #toDatePicker></mat-datepicker>
        </mat-form-field>
        </div>

        <div class="mb-3_t">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>From time</mat-label>
            <input matInput
                   name="selected_time_A"
                   [ngxMatTimepicker]="pickerA"
                   readonly
                   [(ngModel)]="fromtime" />
            <mat-icon matSuffix style="margin-right: 4px;" (click)="pickerA.open()">
              access_time
            </mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker #pickerA></ngx-mat-timepicker>
        </div>
        
        <div class="mb-3_t">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>To time</mat-label>
            <input matInput
                   name="selected_time_B"
                   [ngxMatTimepicker]="pickerB"
                   readonly
                   [(ngModel)]="totime" />
            <mat-icon matSuffix style="margin-right: 4px;" (click)="pickerB.open()">
              access_time
            </mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker #pickerB></ngx-mat-timepicker>
        </div>
        <div class="mb-3_t">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Notes*</mat-label>
            <textarea
              matInput
              rows="2"
              id="notes"
              name="notes1"
              [(ngModel)]="notes"
              placeholder="Notes">
            </textarea>
          </mat-form-field>
        </div>
      </form>
    </div>

    <!-- placeholdr section start -->
    <!-- <div class="row">
      <div class="col-sm-12">
        <div class="notif-empty">
          <div class="notif-empty-content">
            <div class="notif-icon">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g data-name="15 Chat"><path d="M272.57 165.56H25a25 25 0 0 1 0-50h247.6a25 25 0 0 1 0 50zM487 165.56h-62.58a25 25 0 0 1 0-50H487a25 25 0 0 1 0 50zM487 396.44H239.43a25 25 0 0 1 0-50H487a25 25 0 0 1 0 50zM87.58 396.44H25a25 25 0 0 1 0-50h62.58a25 25 0 0 1 0 50z" fill="#969696" opacity="1" data-original="#000000" class=""></path><path d="M163.51 470.52a100.93 100.93 0 1 1 100.92-100.93 101 101 0 0 1-100.92 100.93zm0-151.85a50.93 50.93 0 1 0 50.92 50.92 51 51 0 0 0-50.92-50.92zM348.49 241.49a100.93 100.93 0 1 1 100.93-100.93 101 101 0 0 1-100.93 100.93zm0-151.85a50.93 50.93 0 1 0 50.93 50.92 51 51 0 0 0-50.93-50.92z" fill="#969696" opacity="1" data-original="#000000" class=""></path></g></g></svg>
            </div>
          <div class="notif-empty-text">
            <h3>No unavailability data</h3>
            <p> There's no information of any shop/service unavailability for today or in future. You can set one with the plus (+) button top right. </p>
          </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- placeholdr section end -->
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
     mat-flat-button
     color="accent"      
     (click)="onSave()"
     [disabled]="
     !fromDate || !toDate || !fromtime || !totime
     "
     >Save
  </button>
</mat-dialog-actions>